<template>
  <div class="logistics">
    <div class="logisticsCon">
      <div class="company acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="iconfont icon-wuliu"></div>
          <div class="text">
            <div>
              <span class="name line1">物流公司：</span>
              {{ orderInfo.delivery_name }}
            </div>
            <div class="express line1">
              <span class="name">快递单号：</span> {{ orderInfo.delivery_id }}
            </div>
          </div>
        </div>
        <div
          class="copy acea-row row-center-wrapper copy-data"
          :data-clipboard-text="orderInfo.delivery_id"
        >
          复制单号
        </div>
      </div>
      <div class="item" v-for="(express, index) in expressList" :key="index">
        <div class="circular" :class="index === 0 ? 'on' : ''"></div>
        <div class="text">
          <div :class="index === 0 ? 'font-color-red' : ''">
            {{ express.context }}
          </div>
          <div class="data">{{ express.time }}</div>
        </div>
      </div>
    </div>
    <div class="no-express" v-if="loaded && !expressList.length">
      <img src="@assets/images/noExpress.png" />
    </div>
    <Recommend></Recommend>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import ClipboardJS from "clipboard";
import { getRefundLogistics } from "@api/order";

const NAME = "Logistics";

export default {
  name: NAME,
  components: {
    Recommend
  },
  data: function() {
    return {
      id: this.$route.params.id,
      orderInfo: {},
      expressList: [],
      loaded: false
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.$route.params.id !== this.id) {
        this.id = this.$route.params.id;
        this.getRefundLogistics();
      }
    }
  },
  mounted: function() {
    this.getRefundLogistics();
  },
  methods: {
	getRefundLogistics(){
		let that = this;
		getRefundLogistics(this.id).then(res => {
			that.orderInfo = res.data.order;
			const result = res.data.express || {};
			this.expressList = result.data || [];
			this.loaded = true;
			this.$nextTick(function() {
			  var copybtn = document.getElementsByClassName("copy-data");
			  const clipboard = new ClipboardJS(copybtn);
			  clipboard.on("success", () => {
			    this.$dialog.success("复制成功");
			  });
			});
		}).catch(err => {
			this.$dialog.error(err.msg || "加载失败");
		});
	}
  }
};
</script>

<style scoped>
.no-express {
  margin: 1.5rem 0;
}

.no-express img {
  width: 6rem;
  margin: 0 auto;
  display: block;
}
.item:last-child .text{
	border-left: none;
}
.logistics .logisticsCon{margin-top: 0;}
@media screen and (min-width:960px){
	.no-express {
	  margin: 0.75rem 0;
	}
	.no-express img {
	  width: 3rem;
	}
}
</style>
